exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item__content{\n    width: auto;\n}\n.ml15 {\n  margin-left: 15px;\n}\n.pt15 {\n  padding: 15px 0;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 15px;\n}\n.redtip {\n  color: #ee4b31;\n  position: relative;\n  left: -120px;\n}\ninput[type=\"file\"] {\n  display: none;\n}\n.upload-demo {\n  display: inline-block;\n}\n#import_user .el-select {\n  width: 345px;\n}\n#selssq .el-select {\n  width: 112px;\n}\n#import_user .el-upload__input{\n  display:none;\n}\n.el-message{\n  padding:15px;\n  min-width:50px;\n}\n.importMsg .el-message-box__content{\n\tmax-height: 300px;\n  overflow-y: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c4a92106","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/physical/import.vue
// module id = Ff9K
// module chunks = 3